module.exports = __webpack_public_path__ + "static/media/warrior.aa7e66d8.png";